/**
 * Servicio de contador global.
 * Requiere un endpoint backend (por ejemplo Google Apps Script Web App)
 * para poder incrementar de forma atomica y compartir entre todos los usuarios.
 */

const COUNTER_API_URL = process.env.REACT_APP_COUNTER_API_URL;

const parseCount = (payload) => {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  const value = Number(payload.count);
  return Number.isFinite(value) ? value : null;
};

/**
 * Incrementa el contador global en 1 y retorna el nuevo valor
 */
export const incrementGlobalCounter = async () => {
  try {
    if (!COUNTER_API_URL) {
      console.warn("REACT_APP_COUNTER_API_URL no configurado, usando contador local");
      return null;
    }

    const response = await fetch(COUNTER_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=utf-8"
      },
      body: JSON.stringify({ action: "increment" })
    });

    if (!response.ok) {
      throw new Error(`Error incrementando contador global: ${response.status}`);
    }

    const data = await response.json();
    return parseCount(data);
  } catch (error) {
    console.error("Error al incrementar contador global:", error);
    return null;
  }
};

/**
 * Lee el contador global actual
 */
export const getGlobalCounter = async () => {
  try {
    if (!COUNTER_API_URL) {
      console.warn("REACT_APP_COUNTER_API_URL no configurado, usando contador local");
      return null;
    }

    const response = await fetch(`${COUNTER_API_URL}?action=get`, {
      method: "GET"
    });

    if (!response.ok) {
      throw new Error(`Error leyendo contador global: ${response.status}`);
    }

    const data = await response.json();
    return parseCount(data);
  } catch (error) {
    console.error("Error al leer contador global:", error);
    return null;
  }
};
